import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ContactCard from '../components/ContactCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    setStatus('loading');
    axios.get(`${API}/pages/${slug}`)
      .then(({ data }) => { setPage(data); setStatus('ok'); document.title = `${data.title} · Healsglobe Exports`; window.scrollTo(0, 0); })
      .catch(() => setStatus('missing'));
  }, [slug]);

  return (
    <main className="max-w-3xl mx-auto px-6 py-14 sm:py-20" data-testid="content-page">
      <Link to="/" data-testid="content-page-back" className="inline-flex items-center gap-1.5 text-[13px] text-neutral-500 hover:text-brand transition-colors mb-8"><ArrowLeft size={14} /> Back to shop</Link>
      {status === 'loading' && <div className="h-40 rounded-xl bg-neutral-100 dark:bg-neutral-900 animate-pulse" />}
      {status === 'missing' && (
        <div data-testid="content-page-not-found">
          <h1 className="font-serif text-4xl sm:text-5xl text-neutral-900 dark:text-neutral-100">Page not found</h1>
          <p className="mt-4 text-neutral-500">This page doesn't exist or is no longer available.</p>
        </div>
      )}
      {status === 'ok' && page && (
        <article className="page-fade-in">
          <h1 data-testid="content-page-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-neutral-900 dark:text-neutral-100">{page.title}</h1>
          <div className="mt-4 h-1 w-16 rounded-full bg-brand" />
          {page.slug === 'contact' && <ContactCard />}
          <div data-testid="content-page-body" className="rich-content mt-10 text-neutral-700 dark:text-neutral-300"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content || '', { ADD_ATTR: ['target'] }) }} />
        </article>
      )}
    </main>
  );
};

export default ContentPage;
